/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ListEmailQuicktextsRequest} from '@cash-web/protos/squareup/cash/supportal/service.pb'
import {ListEmailQuicktextsResponse} from '@cash-web/protos/squareup/cash/supportal/service.pb'


export const listEmailQuicktexts = (request: ListEmailQuicktextsRequest, options?: CashRequestOptions) => post<ListEmailQuicktextsRequest, ListEmailQuicktextsResponse>("/2.0/cash/list-email-quicktexts", request, {...options, rejectOnError: true })